export const WEDO_TOKEN = {
  symbol: "WEDO",
  decimals: 18,
};

export const IDO_TOKEN = {
  symbol: "IDO",
  decimals: 18,
};
